import React from 'react';
import './ValueProp.css';

function ValuePropHeader() {
  return <h1 className="header">At BRW we ensure you:</h1>;
}

export default ValuePropHeader;
